var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8175 11.7354L12.9721 14.8767L11.3125 14.3779L13.8175 11.7354Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 14.3779L12.9132 11.9676L13.8175 11.7354L11.3125 14.3779Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5737 9.36607L13.8176 11.7345L12.9133 11.9667L12.5737 9.36607ZM12.5737 9.36607L13.3741 8.75684L13.8176 11.7345L12.5737 9.36607Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5552 7.57671L13.8558 6.54102L13.7415 7.10837L11.5552 7.57671ZM13.6687 7.78995L11.5552 7.57671L13.7415 7.10837L13.6687 7.78995Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6687 7.78995L13.3742 8.75711L11.5552 7.57672L13.6687 7.78995ZM14.1295 6.7809L13.7415 7.10837L13.8558 6.54102L14.1295 6.7809ZM13.6687 7.78995L13.7415 7.10837L14.0498 7.39014L13.6687 7.78995Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52832 13.6123L10.1035 13.8141L11.3127 14.3777L9.52832 13.6123Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3745 8.75656L13.6691 7.7894L13.922 8.00264L13.3745 8.75656ZM13.3745 8.75656L10.9873 7.89221L11.5555 7.57617L13.3745 8.75656Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1237 4.61035L11.5555 7.57656L10.9873 7.8926L12.1237 4.61035Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8558 6.54086L11.5552 7.57656L12.1234 4.61035L13.8558 6.54086Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.123 4.61028L14.5242 4.30566L13.8554 6.54079L12.123 4.61028Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3745 8.75693L12.5742 9.36616L10.9873 7.89258L13.3745 8.75693Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4202 2.16992L14.5242 4.30605L12.123 4.61067L14.4202 2.16992Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4202 2.16992L9.62145 6.00429L9.55908 3.40362L14.4202 2.16992Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99072 3.0918L9.55946 3.40403L9.62182 6.0047L5.99072 3.0918Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9872 7.8926L9.62207 6.00397L12.1237 4.61035L10.9872 7.8926Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9867 7.89258L12.5736 9.36617L10.3457 9.63651L10.9867 7.89258Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3462 9.63647L9.62207 6.00391L10.9872 7.89253L10.3462 9.63647Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1237 4.61067L9.62207 6.00429L14.4208 2.16992L12.1237 4.61067Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02164 14.316L7.15463 15.6144L5.61279 14.0723L6.02164 14.316Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 14.3771L11.8495 12.1343L12.9132 11.9668L11.3125 14.3771Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42773 8.06832L3.38881 5.80273L1.68066 7.79798L1.42773 8.06832Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9134 11.9676L11.8497 12.1351L12.5738 9.3669L12.9134 11.9676ZM9.62183 6.00469L7.71273 5.93616L5.99072 3.0918L9.62183 6.00469Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5736 9.36621L11.8494 12.1344L11.7905 10.7827L12.5736 9.36621Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3457 9.63656L12.5736 9.36621L11.7905 10.7827L10.3457 9.63656Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7124 5.93555L9.6215 6.00409L10.3456 9.63664L7.7124 5.93555Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7126 5.9357L2.56045 0.696289L5.9906 3.09134L7.7126 5.9357ZM5.98713 15.1123L1.51062 16.6354L0.616699 12.8848L5.98713 15.1123Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09229 9.00425L3.78311 7.5459L5.20021 7.90763L2.09229 9.00425Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2003 7.90742L3.7832 7.54569L4.54199 4.10352L5.2003 7.90742Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68018 7.79721L3.78331 7.5459L2.09249 9.00425L1.68018 7.79721Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7905 10.7828L10.9174 10.2993L10.3457 9.63672L11.7905 10.7828Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68072 7.79794L1.53174 6.93359L3.78386 7.54663L1.68072 7.79794Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7373 11.3878L10.9175 10.2988L11.7906 10.7824L10.7373 11.3878Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8495 12.1349L10.7373 11.3886L11.7906 10.7832L11.8495 12.1349Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78341 7.54569L1.53129 6.93265L1.34766 6.20537L3.78341 7.54569ZM4.54219 4.10352L3.78341 7.54569L1.34766 6.20537L4.54219 4.10352ZM4.54219 4.10352L7.71248 5.93503L5.20051 7.90742L4.54219 4.10352Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20068 7.90794L7.71266 5.93555L8.83179 9.69376L5.20068 7.90794ZM8.83179 9.69376L5.36006 9.6138L5.20068 7.90794L8.83179 9.69376Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09229 9.00456L5.20021 7.90794L5.35959 9.6138L2.09229 9.00456ZM10.3454 9.63664L8.83131 9.69376L7.71218 5.93555L10.3454 9.63664Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9174 10.2993L10.7372 11.3883L10.3457 9.63672L10.9174 10.2993Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56006 0.696289L7.7122 5.9357L4.54192 4.10419L2.56006 0.696289Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.616699 12.8855L4.96155 12.6875L5.98713 15.113L0.616699 12.8855Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98701 15.112L4.96143 12.6865L7.09574 12.5723L5.98701 15.112Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7374 11.3885L11.8496 12.1348L12.4628 13.7226L10.7374 11.3885ZM5.36 9.61412L0.616699 12.8849L2.0927 9.00488L5.36 9.61412ZM4.96155 12.6869L0.616699 12.8849L5.36 9.61412L4.96155 12.6869ZM10.3458 9.63696L10.63 10.7717L9.2579 10.8592L10.3458 9.63696ZM9.2579 10.8592L8.83173 9.69408L10.3458 9.63696L9.2579 10.8592Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15494 15.6149L5.9873 15.1123L10.048 15.8624L7.15494 15.6149Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09298 9.00489L1.42773 8.0682L1.68066 7.79785L2.09298 9.00489Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5089 15.3065L10.048 15.8624L5.9873 15.1123L10.5089 15.3065Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7271 13.943L5.9873 15.112L7.09604 12.5723L10.7271 13.943Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9873 15.1123L10.7271 13.9434L10.5089 15.3065L5.9873 15.1123Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34781 6.20547L1.19189 3.27734L4.54235 4.10362L1.34781 6.20547ZM1.68043 7.7971L1.21961 7.28306L1.53144 6.93275L1.68043 7.7971Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05566 10.4483L8.83178 9.69434L8.7209 11.5373L8.05566 10.4483Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83191 9.69434L8.05579 10.4483L6.92627 11.0918L8.83191 9.69434Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4628 13.7228L12.2514 13.5515L10.7373 11.3887L12.4628 13.7228Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92595 11.0917L5.35986 9.61426L8.83159 9.69422L6.92595 11.0917Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72119 11.5373L8.83206 9.69434L9.25823 10.8595L8.72119 11.5373Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06738 6.49544L1.34803 6.20605L1.53167 6.93333L1.06738 6.49544Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72104 11.5372L6.92627 11.0917L8.0558 10.4482L8.72104 11.5372Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54235 4.10419L1.19189 3.27792L2.56049 0.696289L4.54235 4.10419Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0479 15.8627L10.2385 16.4339L7.15479 15.6152L10.0479 15.8627Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09604 12.573L6.92627 11.0918L8.72104 11.5373L7.09604 12.573Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35986 9.61426L6.92595 11.0917L7.09573 12.5729L5.35986 9.61426Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25777 10.8594L10.6298 10.7718L12.2514 13.5514L9.25777 10.8594ZM5.35988 9.61426L7.09574 12.5729L4.96143 12.6871L5.35988 9.61426Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25824 10.8594L10.9629 13.7113L8.72119 11.5371L9.25824 10.8594Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72119 11.5371L10.9629 13.7113L10.7273 13.9436L8.72119 11.5371Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7268 13.9436L7.0957 12.5728L8.72069 11.5371L10.7268 13.9436ZM12.2513 13.5514L10.9624 13.7113L9.25774 10.8594L12.2513 13.5514Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.591 14.8916L12.0366 16.1139L10.2384 16.4337L12.591 14.8916ZM10.2384 16.4337L10.0479 15.8626L10.5087 15.3066L10.2384 16.4337Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5085 15.3066L10.8481 15.1581L10.2383 16.4337L10.5085 15.3066ZM10.2383 16.4337L10.8481 15.1581L12.5909 14.8916L10.2383 16.4337Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2515 13.5508L12.6777 13.8364L11.3818 14.0077L12.2515 13.5508Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3821 14.0077L10.9629 13.7107L12.2518 13.5508L11.3821 14.0077ZM11.2331 14.2324L12.8096 14.0229L12.5913 14.8911L11.2331 14.2324Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5911 14.8913L10.8483 15.1579L11.2329 14.2326L12.5911 14.8913ZM10.8483 15.1579L10.5088 15.3064L10.7271 13.9432L10.8483 15.1579ZM10.7271 13.9432L10.9627 13.7109L11.3819 14.0079L10.7271 13.9432ZM12.6777 13.8366L12.8094 14.0232L11.2329 14.2326L12.6777 13.8366Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2329 14.2329L11.3819 14.0083L12.6777 13.8369L11.2329 14.2329ZM10.7271 13.9435L11.2329 14.2329L10.8483 15.1582L10.7271 13.9435Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.441235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3819 14.0081L11.2329 14.2327L10.7271 13.9434L11.3819 14.0081Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.441235
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(0.549805 0.658203)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.b0f1de65d0073cf65f29d4d71a485670.svg";
export { ForwardRef as ReactComponent };